import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Apis/backlink/Delete";
import Put from "../../../Apis/backlink/Put";
import Post from "../../../Apis/backlink/Post";
import { getAPIUrlBM } from "../../../utils/config";
import DeleteIcon from "../../src/Assets/DeleteIcon";
import SubscriberDropDown from "../../src/Common/SubscriberDropDown/SubscriberDropDown";
import "./style.css";
import NewPageIcon from "../../src/Assets/NewPageIcon";
import CrossIcon from "../../src/Assets/CrossIcon";
import { Tooltip } from "@mui/material";

function ListTable({ data, deleteListItem, setTipLoader, setOnCompleteLoad }) {
  const [updatedData, setUpdatedData] = useState();
  const sweet = window.sweet;
  const [isEdit, setIsEdit] = useState(false);
  const [activeList, setActiveList] = useState(true);
  const [listName, setListName] = useState();
  const [frequency, setFrequency] = useState();
  const [currentNotes, setCurrentNotes] = useState("");
  const [listUsers, setListUsers] = useState();
  const [last_checked_status, setlast_checked_status] = useState();
  const navigate = useNavigate();

  const {
    isPublic,
    isActive,
    // last_checked,
    list_id,
    list_name,
    totalUrls,
    linkStatus,
    linkStatusPercentage,
    notes,
  } = data;

  const toggleActive = async (list_Id, isActive) => {
    try {
      setActiveList(!activeList);
      setIsEdit(false);
      const url = getAPIUrlBM();
      await Put(url + "/toggleActive", {
        listId: list_Id,
        active: !isActive,
      });
      var msg = activeList ? "Deactivated" : "Activated";
      sweet({
        title: "Success!",
        text: list_name + " is " + msg + " Successfully.",
        icon: "success",
      });
      
    } catch (error) {
      console.log(error)
    }
  };

  const [errorEdit, setErrorEdit] = useState({
    listName: {
      msg: "List name should not be more than 25 characters",
      valid: true,
    },
    subcribers: {
      msg: "Atleast one subcribers must be there!!",
      valid: true,
    },
  });

  const editListValidation = () => {
    setErrorEdit({
      listName: {
        msg: "List name should not be more than 25 characters",
        valid: true,
      },
      subcribers: {
        msg: "Atleast one subcribers must be there!!",
        valid: true,
      },
    });
    var isValidEdit = true;

    if (updatedData.connectedUsers.length === 0) {
      setErrorEdit({
        ...errorEdit,
        subcribers: {
          msg: "Atleast one subcribers must be there!!",
          valid: false,
        },
      });
      isValidEdit = false;
    }
    if (updatedData.list_name.length === 0) {
      setErrorEdit({
        ...errorEdit,
        listName: {
          msg: "List Name cannot be empty!!",
          valid: false,
        },
      });
      isValidEdit = false;
    }

    return isValidEdit;
  };

  const monitorList = async (list_Id) => {
    try {
      const url = getAPIUrlBM();
  
      const res = await Put(url + "/monitorlist", {
        listId: list_Id,
      });
  
      if (res.message === "Link updated Sucessfully") {
        sweet({
          title: "Success!",
          text: "List is set for monitoring.",
          icon: "success",
        });
      }
      setActiveList(true);
      setlast_checked_status("");
      
    } catch (error) {
      console.log(error)
    }
  };

  const indexList = async (list_Id) => {
    try {
      const url = getAPIUrlBM();
  
      const res = await Put(url + "/indexlist", {
        listId: list_Id,
      });
  
      if (res.message === "Link updated Sucessfully") {
        sweet({
          title: "Success!",
          text: "List is set for indexing.",
          icon: "success",
        });
      }
      setActiveList(true);
      // setlast_checked_status("");
      
    } catch (error) {
      console.log(error)
    }
  };

  const saveChanges = async (list_Id, updatedData) => {
    try{
      setTipLoader(true);
      if (!editListValidation()) {
        sweet({
          title: "Alert!",
          text: `Please Enter valid data.`,
          icon: "info",
        });
        return;
      }
  
      const url = getAPIUrlBM();
      //add new Subs
      const connectedUser = updatedData.connectedUsers;
      const response = await Post(url + "/createsubscriber", {
        emails: connectedUser,
      });
  
      if (response.message === "User Added Successfully") {
        var userArr = [];
        response.response.forEach((id) => {
          userArr.push(id.primary_id);
        });
        console.log(updatedData, "Ankur chaurasia is coming");
        const res = await Put(url + "/editlist", {
          listId: list_Id,
          name: updatedData.list_name,
          frequency: updatedData.frequency_of_checking,
          users: userArr,
          checkIndex: updatedData.check_index,
          notes: updatedData.notes
        });
  
        if (res.message === "Link Edited Sucessfully") {
          setOnCompleteLoad(() => () => {
              setListName(updatedData.list_name);
              setFrequency(updatedData.frequency_of_checking);
              setListUsers(updatedData.connectedUsers);
              setCurrentNotes(updatedData.notes);
              sweet({
                title: "Success!",
                text: "Congo!!! Link Updated successfully",
                icon: "success",
              });
              setIsEdit(!isEdit);
            })
          } 
      }
    }catch(error){
      setTipLoader(false)
    }
  };
  const discardChanges = () => {
    setUpdatedData(data);
    console.log(data);
    setIsEdit(!isEdit);
    sweet({
      title: "Cancel",
      text: "Your changes are discarded!",
      icon: "info",
    });
  };

  useEffect(() => {
    setUpdatedData(data);
    setActiveList(data.isActive);
    setListName(data.list_name);
    setFrequency(data.frequency_of_checking);
    setListUsers(data.connectedUsers);
    setlast_checked_status(data.last_checked);
    setCurrentNotes(data.notes);
  }, [data]);

  const handleDelete = async (list_Id) => {
    window
      .sweet({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this list!",
        icon: "warning",
        buttons: true,
      })
      .then(async (willDelete) => {
        if (!willDelete) {
          window.sweet({
            title: "Your list is safe!",
            icon: "success",
            text: "Your list is not deleted.",
          });
          return;
        }
        const url = getAPIUrlBM();
        const res = await Delete(url + "/deleteList", { listId: list_Id });
        if (res.message === "Delete Successfully") {
          deleteListItem(list_Id);
          sweet({
            title: "Alert!",
            text: `${list_name} is deleted Successfully.`,
            icon: "success",
          });
        } else
          sweet({
            title: "Alert!",
            text: `${list_name} have links so it cannot be deleted. `,
            icon: "info",
          });
      }).catch(err => {
        console.log(err)
      })
  };

  const getSubsList = (subs) => {
    console.log(subs);
    if (subs.length === 0)
      setErrorEdit({
        ...errorEdit,
        subcribers: {
          msg: "Atleast one subcribers must be there!!",
          valid: false,
        },
      });
    else {
      setErrorEdit({
        ...errorEdit,
        subcribers: {
          msg: "Atleast one subcribers must be there!!",
          valid: true,
        },
      });
    }
    setUpdatedData({
      ...updatedData,
      connectedUsers: subs,
    });
  };

  return (
    <>
      <tr
        id={`list${list_id}`}
        className={
          !activeList ? "unActive listTableRow" : "active listTableRow"
        }
      >
        <td className="blue-text pl-2 text-left">{listName}</td>
        <td className="smallCell">
          {isPublic === 0 ? (
            "NO"
          ) : (
            <>
              <span style={{ float: "left" }}> YES </span>
              {isPublic && activeList ? (
                <div
                  className="newPageIcon"
                  onClick={() =>
                    isPublic &&
                    navigate(`/backlink/public/${listName}/${list_id}`)
                  }
                >
                  <NewPageIcon />
                </div>
              ) : null}
            </>
          )}
        </td>

        <td className="smallCell">{frequency}</td>
        <td className=" tooltip-wrap">
          {listUsers?.length > 0 && (
            <span
              className="oneLineRow"
              style={{
                border: "none",
              }}
            >
              {listUsers[0]}
              {listUsers?.length > 1 && (
                <span className="leftMails">+{listUsers?.length - 1}</span>
              )}
            </span>
          )}

          <div className="tooltip-content">{listUsers?.join(" ")}</div>
        </td>
        <td>
          {last_checked_status === ""
            ? "---"
            : new Date(last_checked_status).toLocaleDateString()}
        </td>
        <td className="grey-text smallCell">{totalUrls}</td>
        <td>{currentNotes ? currentNotes : '---'}</td>

        <td className="grey-text mediumCell">
          {`${linkStatus?.Present}(${linkStatusPercentage?.Present}%) | ${linkStatus?.NotChecked}(${linkStatusPercentage?.NotChecked}%) | ${linkStatus?.Absent}(${linkStatusPercentage?.Absent}%) | ${linkStatus?.Error}(${linkStatusPercentage?.Error}%) | ${linkStatus?.Ok}(${linkStatusPercentage?.Ok}%)`}
        </td>
        <td>{data.check_index ? "Yes" : "No"}</td>
        <td>
          <div className="row-center">
            <div className="functionButtons">
              <Tooltip title="Add Links to this list"  placement="left-start">
                <button
                  className={
                    !activeList
                      ? "unActiveButton listTableButton"
                      : "activeListButton listTableButton"
                  }
                  disabled={!activeList}
                  onClick={() => navigate(`/backlink/link/add/${list_id}`)}
                >
                  Add Links
                </button>
              </Tooltip>

              <Tooltip title="See the existing links details for this list." placement="left-start">
                <button
                  className={
                    !activeList
                      ? "unActiveButton listTableButton"
                      : "activeListButton listTableButton"
                  }
                  disabled={!activeList}
                  onClick={() => navigate(`/backlink/link/${list_id}`)}
                >
                  View Links
                </button>
              </Tooltip>

              <Tooltip title="Edit the list details." placement="left-start">
              <button
                className={
                  !activeList
                    ? "unActiveButton listTableButton"
                    : "activeListButton listTableButton"
                }
                disabled={!activeList}
                onClick={() => setIsEdit(!isEdit)}
              >
                {isEdit ? "Editing" : "Edit List"}
              </button>
              </Tooltip>

              <Tooltip title="Initiate real-time monitoring of the links in this list for performance and status" placement="left-start">
              <button
                className={"activeListButton listTableButton"}
                onClick={() => monitorList(list_id)}
              >
                Monitor now
              </button>
              </Tooltip>

              <Tooltip sx={{backgroundColor : 'blue' , fontSize : '10px'}} title="Check the indexing status of the links in this list." placement="left-start">
              <button
                className={"activeListButton listTableButton"}
                onClick={() => indexList(list_id)}
              >
                {"Check Indexing"}
              </button>
              </Tooltip>

            </div>
            <div className="functionButtons">
              <Tooltip title="Temporarily suspend this list's activity without permanently removing it." placement="left-start">
              <div
                onClick={() => toggleActive(list_id, isActive)}
                className={!activeList && "unActiveDelete"}
              >
                <CrossIcon />
              </div>
              </Tooltip>

              <Tooltip title="Permanently delete this list and all its links." placement="left-start">
              <div
                onClick={() => handleDelete(list_id)}
                className={!activeList && "unActiveDelete"}
                style={{ marginTop: "10px" }}
              >
                <DeleteIcon />
              </div>
              </Tooltip>
            </div>
          </div>
        </td>
      </tr>
      {isEdit && (
        <tr className="editListForm listTableRow">
          <td className="listName pl-2" colSpan={2}>
            <div className="listTableDataCell">
            <label className="gridItemInTableHeader updateInputLabel">
              List Name
            </label>
              <input
                type="text"
                value={updatedData.list_name}
                className="updateInput"
                onChange={(e) => {
                  if (e.target.value.length === 0) {
                    setErrorEdit({
                      ...errorEdit,
                      listName: {
                        msg: "It cannot be empty!!",
                        valid: false,
                      },
                    });
                  } else if (e.target.value.length > 25) {
                    setErrorEdit({
                      ...errorEdit,
                      listName: {
                        msg: "Maximum Length is 25 characters",
                        valid: false,
                      },
                    });
                    return;
                  } else {
                    setErrorEdit({
                      ...errorEdit,
                      listName: {
                        msg: "List name should not be more than 25 characters",
                        valid: true,
                      },
                    });
                  }
                  setUpdatedData({ ...updatedData, list_name: e.target.value });
                }}
              />
              {!errorEdit.listName.valid && (
                <p className="errorInput">{errorEdit.listName.msg}</p>
              )}
            </div>
          </td>
          <td colSpan={1}>
          <div className="listTableDataCell">
            <label className="gridItemInTableHeader updateInputLabel">
              Frequency
            </label>
              <select
                name="frequency"
                className="updateInput"
                value={updatedData.frequency_of_checking}
                onChange={(e) =>
                  setUpdatedData({
                    ...updatedData,
                    frequency_of_checking: e.target.value,
                  })
                }
              >
                <option value="Once">Once</option>
                <option value="Weekly">Weekly</option>
                <option value="Bi-Weekly">BiWeekly</option>
                <option value="Monthly">Monthly</option>
              </select>
            </div>
          </td>

          <td className="subscribers" colSpan={3}>
            <div className="listTableDataCell">
              <label className="gridItemInTableHeader updateInputLabel mb-2">
                Subscribers
              </label>
                <SubscriberDropDown
                  getSubsList={getSubsList}
                  curSelectedSubs={updatedData.connectedUsers}
                  pageName="editPage"
                />
            </div>
              {!errorEdit.subcribers.valid && (
                <p className="errorInput">{errorEdit.subcribers.msg}</p>
              )}
          </td>
          {/* <td colSpan={1} /> */}
          <td colSpan={2} >
          <div className="listTableDataCell">
            <label className="gridItemInTableHeader updateInputLabel">
              Notes
            </label>
              <textarea
                className="updateInput text-left"
                value={updatedData.notes}
                onChange={(e) =>
                  setUpdatedData({ ...updatedData, notes: e.target.value })
                }
              />
            </div>
          </td>

          <td colSpan={1}>
          <div className="listTableDataCell">
            <label className="gridItemInTableHeader updateInputLabel">
              Check Indexing
            </label>
              <select
                onChange={(e) =>
                  setUpdatedData({
                    ...updatedData,
                    check_index: e.target.value,
                  })
                }
                className="updateInput"
              >
                <option value="1" selected={data.check_index === 1}>
                  YES
                </option>
                <option value="0" selected={data.check_index === 0}>
                  NO
                </option>
              </select>
            </div>
          </td>

          <td>
            <button
              className="ml-2 saveChanges"
              onClick={() => saveChanges(list_id, updatedData)}
            >
              Save Changes
            </button>
            <button className="ml-2 discardChanges" onClick={discardChanges}>
              Discard Changes
            </button>
          </td>
          {/* <td colSpan={1} /> */}
        </tr>
      )}
    </>
  );
}

export default ListTable;
